import { render } from "./CustomerSearchBox.vue?vue&type=template&id=b8a1da0a"
import script from "./CustomerSearchBox.vue?vue&type=script&lang=js"
export * from "./CustomerSearchBox.vue?vue&type=script&lang=js"

import "./CustomerSearchBox.vue?vue&type=style&index=0&id=b8a1da0a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__